import React from 'react';
import { Field, withFormik } from 'formik';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { pushQueryParams } from 'services/history';
import withQueryParams from 'HOC/withQueryParams';
import Icon, { ICON_NAMES } from 'components/Icon';
import Input from 'components/Input';
import Button from 'components/Button';


const SearchAuthor = props => {
  const { handleSubmit, queryParams } = props;

  return (
    <form onSubmit={handleSubmit}>
      <div className="field-wrap">
        <div className="search-field">
          <div className="search-field__input">
            <Field
              name="author"
              type="text"
              placeholder="search by author"
              component={Input}
              className="field--borderless"
            />
          </div>
          <div className="search-field__button">
            <Button
              bgColor="transparent"
              type="submit"
              width="auto"
              className="btn--search">
              <Icon
                name={ICON_NAMES.search}
                className="btn__icon btn-search-icon" />
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
}

export default compose(
  withQueryParams,
  withFormik({
    mapPropsToValues: (props) => {
      const {queryParams} = props;

      return {
        author: queryParams.author,
      }
    },
    handleSubmit: (values, { props }) => {
      pushQueryParams({ author: values.author });
    },
  }),
)(SearchAuthor);